<template>
    <!-- 合作伙伴 1  -->
    <sub-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg"
        :rightBg="rightBg" />
</template>

<script>
import SubPage from '@/views/components/SubPage.vue'
export default {
    name: 'cooperationOne',
    components: {
        SubPage
    },
    data() {
        return {
            bg: "/img/pay/0--36.png",
            rightBg: "/img/pay/0--65.png",
        }
    },
    computed: {
        title() {
            return this.$t('cooperationOne.title');
        },
        subtitle() {
            return this.$t('cooperationOne.subtitle');
        },
        description() {
            const desc = this.$t('cooperationOne.description');
            return Array.isArray(desc) ? desc : [desc];
        },
        buttonText() {
            return this.$t('common.buttonText');
        }
    }

}
</script>